import { Link } from "react-router-dom";

export default function ArticleCTA() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-accent-500/10 via-accent-100/20 to-primary-100/20 border border-accent-200/30 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-200/20 rounded-full -translate-y-1/3 translate-x-1/3 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary-200/15 rounded-full translate-y-1/3 -translate-x-1/3 pointer-events-none"></div>

          <div className="relative z-10 text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-4">
              Ready to Master Vigorbuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-8 leading-relaxed">
              Dive into our comprehensive guide covering everything from basic setup to advanced techniques. Start optimizing your workflow today with expert-curated resources and tutorials.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/vigorbuy-spreadsheet-guide"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-label font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Read Complete Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-label font-semibold bg-background-50 text-foreground-800 border border-background-300/60 rounded-md hover:border-primary-300/60 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Visit Main Website
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}